// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2fK-S","icon":"style_icon__2KMVh","title":"style_title__HPWIq","menuIcon":"style_menuIcon__3pWAs"};